import 'leaflet-draw/dist/leaflet.draw-src.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';
import { CSSProperties, FC, ReactNode, useLayoutEffect } from 'react';
import { MapContainer, MapContainerProps, TileLayer, ZoomControl } from 'react-leaflet';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface ITcMap extends MapContainerProps {
  children?: ReactNode;
  initialCenter?: [number, number];
  mapStyle?: CSSProperties;
  zoomLevel?: number;
  customHeight?: string;
  noZoomControl?: boolean;
  customKey?: string | number;
}

const TcMap: FC<ITcMap> = ({
  children,
  initialCenter = [35.56336749, 51.35559082],
  mapStyle = { direction: 'ltr', position: 'relative', zIndex: 0 },
  zoomLevel = 11,
  customHeight,
  noZoomControl = false,
  customKey,
  ...props
}) => {
  //state
  const fullScreen = useSelector((state: RootState) => state.setting.fullScreen);

  const element = document.getElementsByClassName('leaflet-control-attribution')?.[0];
  useLayoutEffect(() => {
    if (element) element.classList.add('hidden');
  }, [element]);

  // const tileUrl = 'https://{s}.tiles.mapbox.com/v3/{id}/{z}/{x}/{y}.png';
  // const tileUrl = 'https://igttestapi.tipax.ir/api/v2/MapIrLog/CreateLog/{s}/{z}/{x}/{y}';
  // const tileUrl = 'https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png';
  // const tileUrl = 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png';
  // const attribution = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

  const tileUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  const attribution = '&copy; OpenStreetMap contributors';
  return (
    <div
      id='map'
      className={`w-full border  rounded-xl overflow-hidden ${customHeight ? customHeight : fullScreen ? ' h-[100vh] ' : 'h-[80vh]'}`}
      style={mapStyle}
      key={customKey ? customKey : fullScreen ? '0' : '1'}>
      <div className='relative w-full h-full'>
        <MapContainer center={initialCenter} zoom={zoomLevel} scrollWheelZoom={true} zoomControl={false} {...props}>
          <TileLayer url={tileUrl} attribution={attribution} />
          {!noZoomControl && <ZoomControl position='bottomright' />}
          {children}
        </MapContainer>
      </div>
    </div>
  );
};

export default TcMap;
